import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * HR Selbstcheck – statischer Inhalt aus frontend/public/hr-selbstcheck/index.html
 * (z. B. aus WordPress übernommenes HTML/CSS/JS in einer Datei).
 */
const HrSelbstcheckResource = () => {
  const [searchParams] = useSearchParams();
  const src = useMemo(() => {
    const q = searchParams.toString();
    return q ? `/hr-selbstcheck/index.html?${q}` : '/hr-selbstcheck/index.html';
  }, [searchParams]);

  return (
    <div className="w-full flex-1 flex flex-col min-h-0 bg-slate-100">
      <iframe
        title="HR Selbstcheck"
        src={src}
        className="w-full flex-1 min-h-[520px] border-0 block bg-white"
      />
    </div>
  );
};

export default HrSelbstcheckResource;
